import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [serverMsg, setServerMsg] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const hpVal = (fd.get('website_alt') as string || '').trim();
    if (hpVal) {
      setStatus('success');
      setServerMsg('Thank you for subscribing!');
      setEmail('');
      return;
    }
    setSubmitting(true);
    setStatus('');
    setServerMsg('');
    try {
      const res = await fetch('https://readdy.ai/api/form/d96ara7pg5pqhofcums0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: fd.get('email') as string }).toString(),
      });
      const text = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(text); } catch { /* */ }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setServerMsg('Thank you for subscribing!');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text || 'Something went wrong. Please try again.';
        if (msg.toLowerCase().includes('spam')) {
          setStatus('error');
          setServerMsg('Submission flagged. Please try again.');
        } else {
          setStatus('error');
          setServerMsg(msg);
        }
      }
    } catch {
      setStatus('error');
      setServerMsg('Network error. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const midPoint = Math.ceil(categories.length / 2);
  const leftCats = categories.slice(0, midPoint);
  const rightCats = categories.slice(midPoint);

  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <Link to="/" className="inline-block mb-5">
              <span className="font-heading text-2xl font-bold text-background-50">
                CSS<span className="text-accent-400">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-background-50/70 text-sm leading-relaxed mb-6 max-w-sm">
              The most comprehensive CSSBuy Spreadsheet directory. Discover verified sellers, daily updated product lists, QC guides, and everything you need for smart shopping.
            </p>
            <form onSubmit={handleSubmit} data-readdy-form="" className="flex gap-2 max-w-sm">
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="site-hp" />
              <input
                type="email"
                name="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email for updates"
                className="flex-1 px-4 py-2.5 rounded-full bg-background-50/15 border border-background-50/20 text-background-50 placeholder:text-background-50/40 text-sm focus:outline-none focus:border-background-50/40"
              />
              <button
                type="submit"
                disabled={submitting}
                className="w-10 h-10 rounded-full bg-accent-500 text-background-50 flex items-center justify-center hover:bg-accent-400 transition-all cursor-pointer shrink-0 disabled:opacity-50"
              >
                <i className={`${submitting ? 'ri-loader-4-line animate-spin' : 'ri-send-plane-fill'} text-sm`}></i>
              </button>
            </form>
            {status === 'success' && <p className="text-accent-300 text-xs mt-2">{serverMsg}</p>}
            {status === 'error' && <p className="text-red-400 text-xs mt-2">{serverMsg}</p>}
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-sm font-semibold text-background-50 mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">Home</Link>
              <a href="#categories" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">Categories</a>
              <Link to="/article/cssbuy-spreadsheet-ultimate-guide" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">Ultimate Guide</Link>
              <Link to="/article/cssbuy-vs-kakobuy-comparison" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">CSSBuy vs Kakobuy</Link>
              <Link to="/article/cssbuy-shipping-guide" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">Shipping Guide</Link>
              <Link to="/article/cssbuy-seller-directory" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">Seller Directory</Link>
              <a href="#faq" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">FAQ</a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-sm font-semibold text-background-50 mb-4">Categories</h4>
            <div className="grid grid-cols-2 gap-x-6 gap-y-2.5">
              {leftCats.map((cat) => (
                <a key={cat.name} href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-sm font-semibold text-background-50 mb-4">&nbsp;</h4>
            <div className="grid grid-cols-1 gap-y-2.5">
              {rightCats.map((cat) => (
                <a key={cat.name} href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/15 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} CSSSpreadsheet.buzz. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 rounded-lg border border-background-50/20 flex items-center justify-center text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-all cursor-pointer">
              <i className="ri-external-link-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 rounded-lg border border-background-50/20 flex items-center justify-center text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-all cursor-pointer">
              <i className="ri-twitter-x-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 rounded-lg border border-background-50/20 flex items-center justify-center text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-all cursor-pointer">
              <i className="ri-reddit-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 rounded-lg border border-background-50/20 flex items-center justify-center text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-all cursor-pointer">
              <i className="ri-discord-line text-sm"></i>
            </a>
          </div>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/50 hover:text-background-50 transition-colors whitespace-nowrap">Privacy Policy</a>
            <a href="#" className="text-xs text-background-50/50 hover:text-background-50 transition-colors whitespace-nowrap">Terms</a>
            <a href="#" className="text-xs text-background-50/50 hover:text-background-50 transition-colors whitespace-nowrap">Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
}